/** @format */

import React from 'react';
import '../help.css';
import tw from 'twin.macro';
import styled from 'styled-components';
import Bitmap from '../images/main/Bitmap.png';
import { PrimaryAction } from './hero/BackgroundAsImage';
import { Greenline } from './greenline';
// import { Button } from './button';

const Styledbtn = styled(PrimaryAction)`
	${tw`sm:mt-0 mx-auto bg-btnprimary`}
`;
export const Help = () => {
	return (
		<>
			<h2 className="help-title">
				Clearknox Helps you
				<Greenline />
			</h2>
			<section id="help-section">
				<div className="help-content">
					<div className="help-image">
						<img src={Bitmap} alt="" />
					</div>
				</div>
				<div className="help-text">
					<section>
						<h1 style={{ color: '#F4846B' }}>1. Clean up your past</h1>
						<p>
							Renoix team will work with all three credit bureaus and challanges all negative entries and
							mistakes on your behalf. These bureaus have 30 days to verify each item. If they cannot
							prove it, they must remove it.
						</p>
					</section>
					<section>
						<h1 style={{ color: '#F1D550' }}>2. Track and learn</h1>
						<p>
							Use our secured portal to track our activities and learn how to estalish more responsive
							financial habbits. We love to see how our clients improve everyday.
						</p>
					</section>
					<section>
						<h1 style={{ color: '#87CFA2' }}>3. Change your future</h1>
						<p>
							You can save thousands of dollars , get approved for better care financing, cheaper
							mortgage, better credit cards and reduce financial stress. Let us help your financial
							freedom
						</p>
					</section>
					<div className="help-btn">
						<a href="#form">
							<Styledbtn>Get a Free Credit Audit</Styledbtn>
						</a>
					</div>
				</div>
			</section>
		</>
	);
};
